module.exports = __webpack_public_path__ + "img/3.a555356d.png";